import React from 'react'

import MainNavItem from './MainNavItem'

const navItems = [
  /*{
    icon: 'envelope-white',
    title: 'Nachrichten',
    url: '/message',
    badge: 0, // TODO: get number of unread messages
  },*/
  {
    url: '/rating',
    title: 'Bewertungen',
    icon: 'star-white',
  },
  {
    url: '/museum',
    title: 'Museen',
    icon: 'house-white',
  },
  {
    url: '/program',
    title: 'Programme',
    icon: 'program-white',
  },
  {
    url: '/guidedTour',
    title: 'Führungen',
    icon: 'guided-tour-white',
  },
]

const MainNav = () => {
  return (
    <div
      id="nav-main"
      className="nav nav-main fixed"
    >
      <ul>
        {navItems.map(itemProps => (
          <MainNavItem
            key={itemProps.url}
            active={window.location.href.indexOf(itemProps.url) > -1}
            {...itemProps}
          />
        ))}
      </ul>
    </div>
  )
}

export { MainNav as default }



// WEBPACK FOOTER //
// ./src/base/components/MainNav.js